/**
 * Operations debug helpers.
 *
 * Retains a single runtime utility used by the cache-write self-healing
 * path in `useAllOperations`. The richer instrumentation that lived here
 * during the 2025-Q4 partial-cache investigation has been removed now that
 * the underlying repair logic (`operationsRepair.ts`) lands the fix.
 */

import type { DiscoveryOperation } from './operationsService';

/**
 * Count how many Azure ops carry a malformed `properties.api.id` (i.e. one
 * that ends at `/managedApis` with no connector slug). The cache-write
 * gate compares this count between the in-memory corpus and the persisted
 * cache entry to decide whether to overwrite it.
 */
export const countMalformedAzureIds = (
  ops: readonly DiscoveryOperation[] | undefined,
): number => {
  if (!ops) return 0;
  let count = 0;
  for (const op of ops) {
    const id = op.properties?.api?.id;
    if (id && /\/managedApis\/?$/i.test(id.trim())) count += 1;
  }
  return count;
};
